const routes = [
  // {
  //   path: "/demo",
  //   name: "demo",
  //   component: () => import(/* webpackChunkName: "demo" */ "@/views/Demo.vue"),
  //   meta: {
  //     title: "这是路由案例",
  //   },
  // },
];
export default routes;
